import BrunaAvatarImage from "@/assets/bruna-avatar.png";
import BrunaAvatarMesh from "@/assets/bruna-avatar-mesh.svg";
import { cn } from "@/core/lib/utils";

type BrunaAvatarProps = {
  /** Lado do avatar em px (o avatar é sempre circular). */
  size?: number;
  className?: string;
  /** `data-testid` opcional: o avatar se repete (uma vez por mensagem), então não é fixo. */
  testId?: string;
};

/**
 * Avatar único da Bruna (PED-14256): mesma cara em todos os pontos de entrada.
 * Replica o "Avatar-Superagentes" do Figma: retrato (PNG com fundo transparente) sobre a
 * malha de gradiente "Intelligence" (roxo, índigo e rosa), recortada em círculo.
 *
 * Origem das medidas: Figma "Agentes-IA" (oPEWDMrYmrW6JxLJUDbS37), instância
 * "AI Agents Symbol" de 96×96 no frame "Chat v2" (node 718-16934). A malha mede 174×154
 * para o avatar de 96 e os insets abaixo são os do layer de gradiente exportado.
 * A malha é dimensionada em % do avatar, então o tamanho também pode vir de CSS
 * (ex.: classe responsiva que sobrescreve `size`).
 */
export function BrunaAvatar({
  size = 96,
  className,
  testId,
}: BrunaAvatarProps) {
  return (
    <span
      aria-hidden
      style={{ width: size, height: size }}
      className={cn(
        "relative block shrink-0 overflow-hidden rounded-full",
        className,
      )}
      data-testid={testId}
    >
      {/* Malha: 174×154 para um avatar de 96 (proporções do Figma), em % do avatar. */}
      <span
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        style={{
          width: `${(174 / 96) * 100}%`,
          height: `${(154 / 96) * 100}%`,
        }}
      >
        <span className="absolute inset-[0.65%_0.57%_0.65%_1.15%]">
          <span className="absolute inset-[-31.58%_-28.07%]">
            <img
              src={BrunaAvatarMesh}
              alt=""
              className="block size-full max-w-none"
            />
          </span>
        </span>
      </span>
      <img
        src={BrunaAvatarImage}
        alt=""
        className="absolute inset-0 size-full max-w-none rounded-full border border-black/[0.08] object-cover"
      />
    </span>
  );
}
